export const govBrEvents = [
    'govBrLoginError',
    'govBrLoginErrorSeals',
    'govBrNoUser',
    'govBrSuccess'
]